<template>
    <div class="container-fluid container-fill">
        <div class="row">
            <div class="paper">
                <h2>
                    <b-row cols="2">
                        <b-col cols="12">
                            <router-link to="/Admin"><font-awesome-icon :icon="['fa', 'arrow-left']" style="font-size: 24px;" class="pointer green" /></router-link>
                            Forms <!--<font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="AddRole(name,description)" class="olive-green-text pointer table-refresh client-list" />-->
                            <font-awesome-icon :icon="['fa', 'plus']" style="font-size: 24px;" class="pointer green" @click="OpenNewFormModal()" />
                        </b-col>
                        <b-col cols="3">
                            <input class="form-control" v-model="search" type="text" placeholder="Search" aria-label="Search" @input="RedrawTable()" />
                        </b-col>
                    </b-row>

                </h2>

                <vuetable :fields="FormTableOptions.Fields"
                          :data-manager="DataManager"
                          pagination-path=""
                          :api-mode="false"
                          class="vue-datatable"
                          ref="datatable">

                    <template slot="FormActions" scope="props">
                        <div class="FormActionDiv">
                            <b-row no-gutters>
                                <b-col md="auto" style="padding-right:1rem;">
                                    <font-awesome-icon :icon="['fa', 'edit']" class="pointer orange" style="font-size: 20px;" @click="OpenEditFormModal(props.rowData)" />
                                </b-col>
                                <b-col md="auto" style="padding-right:1rem;">
                                    <font-awesome-icon :icon="['fa', 'file-invoice']" class="pointer green" style="font-size: 20px;" @click="OpenFormBuilderModal(props.rowData)" />

                                </b-col>
                                <b-col md="auto">
                                    <ActionButtonWithIcon :requires-confirmation="true"
                                              confirmation-string="WARNING: You are about to delete this form.  Are you sure?"
                                              endpoint="Admin/FormManagement/DeleteForm"
                                              :payload="{RecordID: props.rowData.Id}"
                                              :perform-global-update="false"
                                              button-variant="link"
                                              button-string=""
                                              button-size="md"
                                              emit-on-success="form-deleted"
                                              v-on:success="RefreshDataTable" 
                                              icon-prefix="fa"
                                              icon-suffix="trash-alt"
                                              icon-color="red"
                                              method="POST"/>
                                </b-col>
                            </b-row>
                        </div>
                    </template>

                    <template slot="HtmlTemplateModal" scope="props">
                        <span class="HtmlTemplateModal">
                            <font-awesome-icon :icon="['fa', 'eye']" style="font-size: 24px;" class="pointer" @click="ViewHTML(props.rowData)" />
                        </span>
                    </template>

                    <template slot="SubProgramModal" scope="props">
                        <span class="SubProgramModal">
                            <b-col md="auto">
                                <font-awesome-icon :icon="['fa', 'plus']" class="pointer green" style="font-size: 20px; margin-right:1rem;" @click="ClearSubProgramForm(props.rowData)" />
                            </b-col>
                            <b-col md="auto">
                                <div v-for="(s,index) in props.rowData.SubProgramMemberships">
                                    <div>
                                        <b-button style="padding-left:0" variant="link" @click="EditSubProgram(props.rowData,index)">{{s.SubProgram.Name}}</b-button>
                                    </div>
                                </div>
                            </b-col>
                        </span>

                    </template>
                </vuetable>
                <!--html view modal-->
                <span class="EditFormBuilderModal">
                    <b-modal ref="edit-form-builder-component-modal" title="Form Properties" hide-footer modal-class="full-screen-modal" id="modal1" @shown="EditFormBuilder()">
                        <b-container fluid>
                            <FormBlockBuilder ref="formbuildercomponent" />
                            <b-form @submit="SaveFormBuilder">
                                <b-row class="modal-btn-row">
                                    <div class="modal-btn-row-div">
                                        <b-button size="md" variant="secondary" @click="CancelFormBuilderModal()">
                                            CANCEL
                                        </b-button>
                                        <b-button size="md" variant="primary" @click="SaveFormBuilder()">
                                            CONFIRM
                                        </b-button>
                                    </div>
                                </b-row>
                            </b-form>
                        </b-container>
                    </b-modal>
                </span>
                <b-modal size="lg" ref="html-component-modal" title="View HTML" hide-footer>
                    <b-container fluid>
                        <b-row>
                            <FormBlock :form-block-item="form.htmlFormTemplate" :input-values="{}" />
                        </b-row>
                    </b-container>
                </b-modal>
                <span class="AddModal">
                    <b-modal ref="add-component-modal" title="SubProgram Properties" hide-footer>
                        <b-container fluid>
                            <b-form @submit="CreateOrUpdateFormSubProgramMembership">
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>SubProgram Membership:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.subProgramId" required>
                                            <option v-for="subprogram in subPrograms" :value="subprogram.Id">
                                                {{subprogram.HomeControllerName}} - {{subprogram.Name}}
                                            </option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Start Date:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <flat-pickr class="form-control" v-model="subProgramForm.startDate" :config="DateConfig" required></flat-pickr>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>End Date:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <flat-pickr class="form-control" v-model="subProgramForm.endDate" :config="DateConfig"></flat-pickr>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Chart Type:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ChartType" required>
                                            <option value="ClientSubProgramMembership">Client SubProgram Membership</option>
                                            <option value="FosterResourceFamily">Foster Resource Family</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Chapter Name:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.ChapterName" type="name" required></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Chapter Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.ChapterLabel" type="name" required></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Section Name:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.SectionName" type="name" required></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Section Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.SectionLabel" type="name" required></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Applicable To Specific Agency:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ApplicableToSpecificAgency">
                                            <option value="false">No</option>
                                            <option value="true">Yes</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Required Frequency:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.RequiredFrequency">
                                            <option value="AsNeeded">As-Needed</option>
                                            <option value="Once">Once</option>
                                            <option value="Weekly">Weekly</option>
                                            <option value="Monthly">Monthly</option>
                                            <option value="Quarterly">Quarterly</option>
                                            <option value="Annually">Annually</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Applicable To Specific Agency:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.FirstDue">
                                            <option value="SubProgramEnrollment">SubProgramEnrollment</option>
                                            <option value="HomePlacement">HomePlacement</option>
                                            <option value="DischargeFromSubProgram">DischargeFromSubProgram</option>
                                            <option value="FamilyCertification">FamilyCertification</option>
                                            <option value="FamilyDecertification">FamilyDecertification</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>First Due Time Adjustment:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.FirstDueTimeAdjustment" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>First Due Time Adjustment Units</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.FirstDueTimeAdjustmentUnits" required>
                                            <option value="Days">Days</option>
                                            <option value="Weeks">Weeks</option>
                                            <option value="Months">Months</option>
                                            <option value="Years">Years</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Arbitrary Expiration Date:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ArbitraryExpirationDate">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Applicable To Specific Age Range:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ApplicableToSpecificAgeRange">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Age Range Applicablity Type:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AgeRangeApplicabilityType">
                                            <option value=""></option>
                                            <option value="Enrollment">Enrollment</option>
                                            <option value="Present">Present</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Age Applicability Minimum:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.AgeApplicabilityMinimum" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Age Applicability Maximum:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.AgeApplicabilityMaximum" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Employee Role Responsible:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.EmployeeRoleResponsible" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><h2>Approval Requirements:</h2></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Author</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AuthorApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.AuthorApprovalLabel" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AuthorSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Author's Supervisor</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AuthorSupervisorApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.AuthorSupervisorApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AuthorSupervisorSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Client</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ClientApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.ClientApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ClientSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Programs Director</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ProgramsDirectorApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.ProgramsDirectorApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ProgramsDirectorSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Single Parent</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.SingleParentApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.SingleParentApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.SingleParentSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>All Parent</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AllParentApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.AllParentApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AllParentSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Worker</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.WorkerApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.WorkerApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.WorkerSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Clinician</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ClinicianApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.ClinicianApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ClinicianSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Department Director</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.DepartmentDirectorApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.DepartmentDirectorApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.DepartmentDirectorSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Executive Director</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ExecutiveDirectorApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.ExecutiveDirectorApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.ExecutiveDirectorSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><legend>Administrative Assistant</legend></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Required:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AdministrativeAssistantApprovalRequired">
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Approval Label:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="subProgramForm.AdministrativeAssistantApprovalLabel" placeholder="Required" type="name"></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12"><b>Signature Line:</b></b-col>
                                </b-row>
                                <b-row no-gutters="true">
                                    <b-col cols="12" style="margin-bottom: 1rem">
                                        <select class="form-control" v-model="subProgramForm.AdministrativeAssistantSignatureLine">
                                            <option value=""></option>
                                            <option value="SignerForSignature1">SignerForSignature1</option>
                                            <option value="SignerForSignature2">SignerForSignature2</option>
                                            <option value="SignerForSignature3">SignerForSignature3</option>
                                            <option value="SignerForSignature4">SignerForSignature4</option>
                                            <option value="SignerForSignature5">SignerForSignature5</option>
                                            <option value="SignerForSignature6">SignerForSignature6</option>
                                        </select>
                                    </b-col>
                                </b-row>
                                <b-row class="modal-btn-row">
                                    <div class="modal-btn-row-div">
                                        <div class="float-left">
                                            <b-button size="md" variant="danger" align-self="start" @click="DeleteSubProgram()">
                                                DELETE
                                            </b-button>
                                        </div>
                                        <b-button size="md" variant="secondary" @click="CancelSubProgramModal()">
                                            CANCEL
                                        </b-button>
                                        <b-button size="md" variant="primary" type="submit">
                                            CONFIRM
                                        </b-button>
                                    </div>
                                </b-row>
                            </b-form>
                        </b-container>
                    </b-modal>
                </span>

            </div>
            <span class="AddModal">
                <b-modal ref="add-form-component-modal" title="Form Properties" hide-footer modal-class="full-screen-modal" id="modal1">
                    <b-container fluid>
                        <b-form @submit="AddNewForm">
                            <b-row cols="2">
                                <b-col>
                                    <b-row no-gutters="true" cols="6">
                                        <b-col cols="12"><b>Name:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.name" type="name" required></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Version:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.version" type="name" required></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Label:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.label" type="name" required></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Form Type:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <select class="form-control" v-model="form.formType" required>
                                            <option value="AllDigital">All Digital</option>
                                            <option value="Scan">Scan</option>
                                            <option value="PaperworkGenerationOnly">Paperwork Generation Only</option>
                                        </select>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Word Template File ID:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="form.wordFileId" type="name"></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Allow Word Imports:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem">
                                            <select class="form-control" v-model="form.allowWordImport">
                                                <option value="true">True</option>
                                                <option value="false">False</option>
                                            </select>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col>
                                    <b-row no-gutters="true">
                                        <b-col cols="12"><b>Html Form Template:</b></b-col>
                                    </b-row>
                                    <b-row no-gutters="true">
                                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-textarea rows="16" v-model="form.htmlFormTemplate" type="name" required></b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row class="modal-btn-row">
                                <div class="modal-btn-row-div">
                                    <b-button size="md" variant="secondary" @click="CancelFormModal()">
                                        CANCEL
                                    </b-button>
                                    <b-button size="md" variant="primary" type=submit>
                                        CONFIRM
                                    </b-button>
                                </div>
                            </b-row>
                        </b-form>
                    </b-container>
                </b-modal>
            </span>
        </div>
    </div>
</template>

<script>
    //import services
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    //import components
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    // import helper functions
    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    import FormBlock from "../Core/RecordComponents/FormBlock.vue";
    import FormBlockBuilder from "../Core/ItemEditors/FormBlockBuilder.vue";
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faPencilAlt);
    import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
    library.add(faArrowLeft);
    import { faEye } from '@fortawesome/free-solid-svg-icons';
    library.add(faEye);
    import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';
    library.add(faFileInvoice);

    import { EventBus } from '../../services/event-bus.js';

    export default {
        name: "FormList",
        created() {
        },
        props: ['HTML'],
        data: function () {
            return {
                search: '',
                FormList: [],
                FormID: [],
                FormSubProgramList: [],
                subPrograms: [],
                form: {
                    formId: '',
                    formType: '',
                    htmlFormTemplate: '',
                    label: '',
                    name: '',
                    version: '',
                    wordFileId: '',
                    allowWordImport: '',
                    //FormField Properties
                    arrayFieldID: [],
                    arrayAutoFieldSelector: [],
                    arrayDefaultValue: [],
                    arrayEmptyReplacementString: [],
                    arrayFieldDataFormatString: [],
                    arrayFieldDataStructure: [],
                    arrayFieldDataType: [],
                    arrayFieldLabel: [],
                    arrayFieldName: [],
                    arrayIsAutoField: [],
                    arrayIsRequired: [],
                    arrayWordTemplateFieldName: [],
                    arrayIsEffectiveDate: []
                },
                subProgramForm: {
                    id: '',
                    startDate: '',
                    endDate: '',
                    ChartType: '',
                    ChapterName: '',
                    ChapterLabel: '',
                    SectionName: '',
                    SectionLabel: '',
                    ApplicableToSpecificAgency: '',
                    RequiredFrequency: '',
                    FirstDue: '',
                    FirstDueTimeAdjustment: '',
                    FirstDueTimeAdjustmentUnits: '',
                    ArbitraryExpirationDate: '',
                    ApplicableToSpecificAgeRange: '',
                    AgeRangeApplicabilityType: '',
                    AgeApplicabilityMinimum: '',
                    AgeApplicabilityMaximum: '',
                    EmployeeRoleResponsible: '',
                    AuthorApprovalRequired: 'false',
                    AuthorApprovalLabel: '',
                    AuthorSignatureLine: '',
                    AuthorSupervisorApprovalRequired: 'false',
                    AuthorSupervisorApprovalLabel: '',
                    AuthorSupervisorSignatureLine: '',
                    ClientApprovalRequired: 'false',
                    ClientApprovalLabel: '',
                    ClientSignatureLine: '',
                    ProgramDirectorApprovalRequired: 'false',
                    ProgramsDirectorApprovalLabel: '',
                    ProgramDirectorSignatureLine: '',
                    SingleParentApprovalRequired: 'false',
                    SingleParentApprovalLabel: '',
                    SingleParentSignatureLine: '',
                    AllParentApprovalRequired: 'false',
                    AllParentApprovalLabel: '',
                    AllParentSignatureLine: '',
                    WorkerApprovalRequired: 'false',
                    WorkerApprovalLabel: '',
                    WorkerSignatureLine: '',
                    ClinicianApprovalRequired: 'false',
                    ClinicianApprovalLabel: '',
                    ClinicianSignatureLine: '',
                    DepartmentDirectorApprovalRequired: 'false',
                    DepartmentDirectorApprovalLabel: '',
                    DepartmentDirectorSignatureLine: '',
                    ExecutiveDirectorApprovalRequired: 'false',
                    ExecutiveDirectorApprovalLabel: '',
                    ExecutiveDirectorSignatureLine: '',
                    AdministrativeAssistantApprovalRequired: 'false',
                    AdministrativeAssistantApprovalLabel: '',
                    AdministrativeAssistantSignatureLine: '',
                    subProgramId: '',
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
                FormTableOptions: {
                    Fields: [
                        {
                            name: 'Name',
                            title: 'Name',
                            sortField: "Name",
                            width: "12%"
                        },
                        {
                            name: 'Version',
                            title: 'Version',
                            sortField: "Version",
                            width: "12%"
                        },
                        {
                            name: 'Label',
                            title: 'Label',
                            sortField: "Label",
                            width: "12%"
                        },
                        {
                            name: '__slot:HtmlTemplateModal',
                            title: 'HtmlFormTemplate',
                            width: "5%"
                        },
                        {
                            name: 'FormType',
                            title: 'FormType',
                            sortField: "FormType",
                            width: "10%"
                        },
                        {
                            name: '__slot:SubProgramModal',
                            title: 'SubPrograms',
                            width: "12%"
                        },
                        {
                            name: 'UpdatedBy',
                            title: 'UpdatedBy',
                            sortField: "UpdatedBy",
                            width: "12%"
                        },
                        {
                            name: 'UpdatedAt',
                            title: 'UpdatedAt',
                            sortField: "UpdatedAt",
                            width: "15%"
                        },
                        {
                            name: '__slot:FormActions',
                            title: 'Actions',
                            width: "15%"
                        }
                    ]
                }
            };
        },
        methods: {
            SaveFormBuilder() {
                let vm = this;
                this.form.htmlFormTemplate = this.$refs['formbuildercomponent'].ReturnExportForm();
                this.$MasterAPI.ExecuteRequest("POST", "Admin/FormManagement/UpdateHtmlFormTemplate",{
                        Id: vm.form.formId,
                        HtmlFormTemplate: vm.form.htmlFormTemplate,
                    }, this.SaveFormBuilderSuccess, () => { }, true);

            },
            SaveFormBuilderSuccess(response) {
                this.RefreshDataTable();
                this.$refs['edit-form-builder-component-modal'].hide();
            },
            CancelFormBuilderModal() {
                this.$refs['edit-form-builder-component-modal'].hide();
            },
            OpenFormBuilderModal(rowData) {
                this.form.formId = rowData.Id;
                this.form.formType = rowData.FormType;
                this.form.htmlFormTemplate = rowData.HtmlFormTemplate;
                this.form.label = rowData.Label;
                this.form.name = rowData.Name;
                this.form.version = rowData.Version;
                this.form.wordFileId = rowData.WordFileID;
                this.form.allowWordImport = rowData.AllowWordImport;
                this.$refs['edit-form-builder-component-modal'].show(); 
            },
            EditFormBuilder() {
                this.$refs['formbuildercomponent'].ImportFormFromExternalData(this.form.htmlFormTemplate);
            },
            OpenEditFormModal(rowData) {
                this.form.formId = rowData.Id;
                this.form.formType = rowData.FormType;
                this.form.htmlFormTemplate = rowData.HtmlFormTemplate;
                this.form.label = rowData.Label;
                this.form.name = rowData.Name;
                this.form.version = rowData.Version;
                this.form.wordFileId = rowData.WordFileID;
                this.form.allowWordImport = rowData.AllowWordImport;
                this.$refs['add-form-component-modal'].show();
            },
            OpenNewFormModal() {
                this.form.formId = "";
                this.form.formType = "";
                this.form.htmlFormTemplate = "{\"BlockType\":\"Container\",\"ContainerType\":\"ElementContainer\",\"ChildBlocks\":[],\"Active\":true,\"Title\":\"Container: Element Container\",\"Index\":0}";
                this.form.label = "";
                this.form.name = "";
                this.form.version = "";
                this.form.wordFileId = "";
                this.form.allowWordImport = "";
                this.$refs['add-form-component-modal'].show();
            },
            ViewHTML(rowData) {
                this.form.htmlFormTemplate = JSON.parse(rowData.HtmlFormTemplate);
                this.$refs['html-component-modal'].show();
            },
            ViewSubPrograms(rowData) {
                this.GetFormSubProgram(rowData.Id)
                this.$refs['add-component-modal'].show();
            },
            EditSubProgram(rowData, index) {
                this.subProgramForm.id = rowData.SubProgramMemberships[index].Id;
                this.subProgramForm.startDate = moment(new Date(rowData.SubProgramMemberships[index].StartDate)).format('MM/DD/YYYY');
                if (rowData.SubProgramMemberships[index].EndDate != null)
                    this.subProgramForm.endDate = moment(new Date(rowData.SubProgramMemberships[index].EndDate)).format('MM/DD/YYYY');
                else
                    this.subProgramForm.endDate = '';
                this.subProgramForm.ChartType = rowData.SubProgramMemberships[index].ChartType;
                this.subProgramForm.ChapterName = rowData.SubProgramMemberships[index].ChapterName;
                this.subProgramForm.ChapterLabel = rowData.SubProgramMemberships[index].ChapterLabel;
                this.subProgramForm.SectionName = rowData.SubProgramMemberships[index].SectionName;
                this.subProgramForm.SectionLabel = rowData.SubProgramMemberships[index].SectionLabel;
                this.subProgramForm.ApplicableToSpecificAgency = rowData.SubProgramMemberships[index].ApplicableToSpecificAgency;
                this.subProgramForm.RequiredFrequency = rowData.SubProgramMemberships[index].RequiredFrequency;
                this.subProgramForm.FirstDue = rowData.SubProgramMemberships[index].FirstDue;
                this.subProgramForm.FirstDueTimeAdjustment = rowData.SubProgramMemberships[index].FirstDueTimeAdjustment;
                this.subProgramForm.FirstDueTimeAdjustmentUnits = rowData.SubProgramMemberships[index].FirstDueTimeAdjustmentUnits;
                this.subProgramForm.ArbitraryExpirationDate = rowData.SubProgramMemberships[index].ArbitraryExpirationDate;
                this.subProgramForm.ApplicableToSpecificAgeRange = rowData.SubProgramMemberships[index].ApplicableToSpecificAgeRange;
                this.subProgramForm.AgeRangeApplicabilityType = rowData.SubProgramMemberships[index].AgeRangeApplicabilityType;
                this.subProgramForm.AgeApplicabilityMinimum = rowData.SubProgramMemberships[index].AgeApplicabilityMinimum;
                this.subProgramForm.AgeApplicabilityMaximum = rowData.SubProgramMemberships[index].AgeApplicabilityMaximum;
                this.subProgramForm.EmployeeRoleResponsible = rowData.SubProgramMemberships[index].EmployeeRoleResponsible;
                this.subProgramForm.AuthorApprovalRequired = rowData.SubProgramMemberships[index].AuthorApprovalRequired;
                this.subProgramForm.AuthorApprovalLabel = rowData.SubProgramMemberships[index].AuthorApprovalLabel;
                this.subProgramForm.AuthorSignatureLine = rowData.SubProgramMemberships[index].AuthorSignatureLine;
                this.subProgramForm.AuthorSupervisorApprovalRequired = rowData.SubProgramMemberships[index].AuthorSupervisorApprovalRequired;
                this.subProgramForm.AuthorSupervisorApprovalLabel = rowData.SubProgramMemberships[index].AuthorSupervisorApprovalLabel;
                this.subProgramForm.AuthorSupervisorSignatureLine = rowData.SubProgramMemberships[index].AuthorSupervisorSignatureLine;
                this.subProgramForm.ClientApprovalRequired = rowData.SubProgramMemberships[index].ClientApprovalRequired;
                this.subProgramForm.ClientApprovalLabel = rowData.SubProgramMemberships[index].ClientApprovalLabel;
                this.subProgramForm.ClientSignatureLine = rowData.SubProgramMemberships[index].ClientSignatureLine;
                this.subProgramForm.ProgramDirectorApprovalRequired = rowData.SubProgramMemberships[index].ProgramDirectorApprovalRequired;
                this.subProgramForm.ProgramsDirectorApprovalLabel = rowData.SubProgramMemberships[index].ProgramsDirectorApprovalLabel;
                this.subProgramForm.ProgramDirectorSignatureLine = rowData.SubProgramMemberships[index].ProgramDirectorSignatureLine;
                this.subProgramForm.SingleParentApprovalRequired = rowData.SubProgramMemberships[index].SingleParentApprovalRequired;
                this.subProgramForm.SingleParentApprovalLabel = rowData.SubProgramMemberships[index].SingleParentApprovalLabel;
                this.subProgramForm.SingleParentSignatureLine = rowData.SubProgramMemberships[index].SingleParentSignatureLine;
                this.subProgramForm.AllParentApprovalRequired = rowData.SubProgramMemberships[index].AllParentApprovalRequired;
                this.subProgramForm.AllParentApprovalLabel = rowData.SubProgramMemberships[index].AllParentApprovalLabel;
                this.subProgramForm.AllParentSignatureLine = rowData.SubProgramMemberships[index].AllParentSignatureLine;
                this.subProgramForm.WorkerApprovalRequired = rowData.SubProgramMemberships[index].WorkerApprovalRequired;
                this.subProgramForm.WorkerApprovalLabel = rowData.SubProgramMemberships[index].WorkerApprovalLabel;
                this.subProgramForm.WorkerSignatureLine = rowData.SubProgramMemberships[index].WorkerSignatureLine;
                this.subProgramForm.ClinicianApprovalRequired = rowData.SubProgramMemberships[index].ClinicianApprovalRequired;
                this.subProgramForm.ClinicianApprovalLabel = rowData.SubProgramMemberships[index].ClinicianApprovalLabel;
                this.subProgramForm.ClinicianSignatureLine = rowData.SubProgramMemberships[index].ClinicianSignatureLine;
                this.subProgramForm.DepartmentDirectorApprovalRequired = rowData.SubProgramMemberships[index].DepartmentDirectorApprovalRequired;
                this.subProgramForm.DepartmentDirectorApprovalLabel = rowData.SubProgramMemberships[index].DepartmentDirectorApprovalLabel;
                this.subProgramForm.DepartmentDirectorSignatureLine = rowData.SubProgramMemberships[index].DepartmentDirectorSignatureLine;
                this.subProgramForm.ExecutiveDirectorApprovalRequired = rowData.SubProgramMemberships[index].ExecutiveDirectorApprovalRequired;
                this.subProgramForm.ExecutiveDirectorApprovalLabel = rowData.SubProgramMemberships[index].ExecutiveDirectorApprovalLabel;
                this.subProgramForm.ExecutiveDirectorSignatureLine = rowData.SubProgramMemberships[index].ExecutiveDirectorSignatureLine;
                this.subProgramForm.AdministrativeAssistantApprovalRequired = rowData.SubProgramMemberships[index].AdministrativeAssistantApprovalRequired;
                this.subProgramForm.AdministrativeAssistantApprovalLabel = rowData.SubProgramMemberships[index].AdministrativeAssistantApprovalLabel;
                this.subProgramForm.AdministrativeAssistantSignatureLine = rowData.SubProgramMemberships[index].AdministrativeAssistantSignatureLine;
                this.subProgramForm.subProgramId = rowData.SubProgramMemberships[index].SubProgram.Id;
                this.form.formId = rowData.SubProgramMemberships[index].FormID;
                this.$refs['add-component-modal'].show();
            },
            ClearSubProgramForm(rowData) {
                this.subProgramForm.startDate = "";
                this.subProgramForm.endDate = "";
                this.subProgramForm.ChartType = "";
                this.subProgramForm.ChapterName = "";
                this.subProgramForm.ChapterLabel = "";
                this.subProgramForm.SectionName = "";
                this.subProgramForm.SectionLabel = "";
                this.subProgramForm.ApplicableToSpecificAgency = "";
                this.subProgramForm.RequiredFrequency = "";
                this.subProgramForm.FirstDue = "";
                this.subProgramForm.FirstDueTimeAdjustment = "";
                this.subProgramForm.FirstDueTimeAdjustmentUnits = "";
                this.subProgramForm.ArbitraryExpirationDate = "";
                this.subProgramForm.ApplicableToSpecificAgeRange = "";
                this.subProgramForm.AgeRangeApplicabilityType = "";
                this.subProgramForm.AgeApplicabilityMinimum = "";
                this.subProgramForm.AgeApplicabilityMaximum = "";
                this.subProgramForm.EmployeeRoleResponsible = "";
                this.subProgramForm.AuthorApprovalRequired = "false";
                this.subProgramForm.AuthorApprovalLabel = "";
                this.subProgramForm.AuthorSignatureLine = "";
                this.subProgramForm.AuthorSupervisorApprovalRequired = "false";
                this.subProgramForm.AuthorSupervisorApprovalLabel = "";
                this.subProgramForm.AuthorSupervisorSignatureLine = "";
                this.subProgramForm.ClientApprovalRequired = "false";
                this.subProgramForm.ClientApprovalLabel = "";
                this.subProgramForm.ClientSignatureLine = "";
                this.subProgramForm.ProgramDirectorApprovalRequired = "false";
                this.subProgramForm.ProgramsDirectorApprovalLabel = "";
                this.subProgramForm.ProgramDirectorSignatureLine = "";
                this.subProgramForm.SingleParentApprovalRequired = "false";
                this.subProgramForm.SingleParentApprovalLabel = "";
                this.subProgramForm.SingleParentSignatureLine = "";
                this.subProgramForm.AllParentApprovalRequired = "false";
                this.subProgramForm.AllParentApprovalLabel = "";
                this.subProgramForm.AllParentSignatureLine = "";
                this.subProgramForm.WorkerApprovalRequired = "false";
                this.subProgramForm.WorkerApprovalLabel = "";
                this.subProgramForm.WorkerSignatureLine = "";
                this.subProgramForm.ClinicianApprovalRequired = "false";
                this.subProgramForm.ClinicianApprovalLabel = "";
                this.subProgramForm.ClinicianSignatureLine = "";
                this.subProgramForm.DepartmentDirectorApprovalRequired = "false";
                this.subProgramForm.DepartmentDirectorApprovalLabel = "";
                this.subProgramForm.DepartmentDirectorSignatureLine = "";
                this.subProgramForm.ExecutiveDirectorApprovalRequired = "false";
                this.subProgramForm.ExecutiveDirectorApprovalLabel = "";
                this.subProgramForm.ExecutiveDirectorSignatureLine = "";
                this.subProgramForm.AdministrativeAssistantApprovalRequired = "false";
                this.subProgramForm.AdministrativeAssistantApprovalLabel = "";
                this.subProgramForm.AdministrativeAssistantSignatureLine = "";
                this.subProgramForm.subProgramId = "";
                this.form.formId = rowData.Id;
                this.$refs['add-component-modal'].show();
            },
            ButtonClick() {
                this.ShowModal()
            },
            ShowModal() {
                this.$refs['add-component-modal'].show();
            },
            CancelFormModal() {
                this.$refs['add-form-component-modal'].hide();
            },
            CancelSubProgramModal() {
                this.$refs['add-component-modal'].hide();
            },
            RefreshDataTable() {
                this.GetForms();
            },
            AddNewForm(e) {
                e.preventDefault();
                let vm = this;
                this.$MasterAPI.ExecuteRequest("POST", "Admin/FormManagement/CreateOrUpdateForm",
                    {
                        FormID: vm.form.formId,
                        //Form Properties
                        FormType: vm.form.formType,
                        HtmlFormTemplate: vm.form.htmlFormTemplate,
                        Label: vm.form.label,
                        Name: vm.form.name,
                        Version: vm.form.version,
                        WordFileID: vm.form.wordFileId,
                        AllowWordImport: vm.form.AllowWordImport,
                        //FormField Properties
                        ArrayFieldID: vm.form.arrayFieldID,
                        ArrayAutoFieldSelector: vm.form.arrayAutoFieldSelector,
                        ArrayDefaultValue: vm.form.arrayDefaultValue,
                        ArrayEmptyReplacementString: vm.form.arrayEmptyReplacementString,
                        ArrayFieldDataFormatString: vm.form.arrayFieldDataFormatString,
                        ArrayFieldDataStructure: vm.form.arrayFieldDataStructure,
                        ArrayFieldDataType: vm.form.arrayFieldDataType,
                        ArrayFieldLabel: vm.form.arrayFieldLabel,
                        ArrayFieldName: vm.form.arrayFieldName,
                        ArrayIsAutoField: vm.form.arrayIsAutoField,
                        ArrayIsRequired: vm.form.arrayIsRequired,
                        ArrayWordTemplateFieldName: vm.form.arrayWordTemplateFieldName,
                        ArrayIsEffectiveDate: vm.form.arrayIsEffectiveDate
                    },
                    this.AddNewFormSuccess, () => { }, true);
            },
            AddNewFormSuccess(response) {
                this.RefreshDataTable();
                this.$refs['add-form-component-modal'].hide();
            },
            CreateOrUpdateFormSubProgramMembership(e) {
                e.preventDefault();
                //let vm = this;
                var formattedDate = moment(new Date(this.subProgramForm.startDate)).format('YYYY-MM-DD')               
                if (this.subProgramForm.endDate == "")
                    var formattedEndDate = null;
                else
                    var formattedEndDate  = moment(new Date(this.subProgramForm.endDate)).format('YYYY-MM-DD');
                this.$MasterAPI.ExecuteRequest("POST", "Admin/FormManagement/CreateOrUpdateFormSubProgramMembership",
                    {
                        Id: this.subProgramForm.id,
                        FormID: this.form.formId,
                        SubProgramID: this.subProgramForm.subProgramId,
                        StartDate: formattedDate,
                        EndDate: formattedEndDate,
                        ChartType: this.subProgramForm.ChartType,
                        ChapterName: this.subProgramForm.ChapterName,
                        ChapterLabel: this.subProgramForm.ChapterLabel,
                        SectionName: this.subProgramForm.SectionName,
                        SectionLabel: this.subProgramForm.SectionLabel,
                        ApplicableToSpecificAgency: this.subProgramForm.ApplicableToSpecificAgency,

                        RequiredFrequency: this.subProgramForm.RequiredFrequency,
                        FirstDue: this.subProgramForm.FirstDue,
                        FirstDueTimeAdjustment: this.subProgramForm.FirstDueTimeAdjustment,
                        FirstDueTimeAdjustmentUnits: this.subProgramForm.FirstDueTimeAdjustmentUnits,
                        ArbitraryExpirationDate: this.subProgramForm.ArbitraryExpirationDate,
                        ApplicableToSpecificAgeRange: this.subProgramForm.ApplicableToSpecificAgeRange,
                        AgeRangeApplicabilityType: this.subProgramForm.AgeRangeApplicabilityType,
                        AgeApplicabilityMinimum: this.subProgramForm.AgeApplicabilityMinimum,
                        AgeApplicabilityMaximum: this.subProgramForm.AgeApplicabilityMaximum,
                        EmployeeRoleResponsible: this.subProgramForm.EmployeeRoleResponsible,
                        AuthorApprovalRequired: this.subProgramForm.AuthorApprovalRequired,
                        AuthorApprovalAssignedSignatureLine: this.subProgramForm.AuthorApprovalAssignedSignatureLine,
                        AuthorApprovalLabel: this.subProgramForm.AuthorApprovalLabel,

                        AuthorSupervisorApprovalRequired: this.subProgramForm.AuthorSupervisorApprovalRequired,
                        AuthorSupervisorApprovalAssignedSignatureLine: this.subProgramForm.AuthorSupervisorApprovalAssignedSignatureLine,
                        AuthorSupervisorApprovalLabel: this.subProgramForm.AuthorSupervisorApprovalLabel,
                        WorkerApprovalRequired: this.subProgramForm.WorkerApprovalRequired,
                        WorkerApprovalAssignedSignautreLine: this.subProgramForm.WorkerApprovalAssignedSignautreLine,
                        WorkerApprovalLabel: this.subProgramForm.WorkerApprovalLabel,
                        ClientApprovalRequired: this.subProgramForm.ClientApprovalRequired,
                        ClientApprovalAssignedSignatureLine: this.subProgramForm.ClientApprovalAssignedSignatureLine,

                        ClientApprovalLabel: this.subProgramForm.ClientApprovalLabel,
                        ClinicianApprovalRequired: this.subProgramForm.ClinicianApprovalRequired,
                        ClinicianApprovalAssignedSignatureLine: this.subProgramForm.ClinicianApprovalAssignedSignatureLine,
                        ClinicianApprovalLabel: this.subProgramForm.ClinicianApprovalLabel,
                        SingleParentApprovalRequired: this.subProgramForm.SingleParentApprovalRequired,
                        SingleParentApprovalAssignedSignatureLine: this.subProgramForm.SingleParentApprovalAssignedSignatureLine,
                        SingleParentApprovalLabel: this.subProgramForm.SingleParentApprovalLabel,
                        AllParentApprovalRequired: this.subProgramForm.AllParentApprovalRequired,
                        AllParentApprovalAssignedSignatureLine: this.subProgramForm.AllParentApprovalAssignedSignatureLine,
                        AllParentApprovalLabel: this.subProgramForm.AllParentApprovalLabel,
                        DepartmentDirectorApprovalRequired: this.subProgramForm.DepartmentDirectorApprovalRequired,
                        DepartmentDirectorApprovalAssignedSignautreLine: this.subProgramForm.DepartmentDirectorApprovalAssignedSignautreLine,
                        DepartmentDirectorApprovalLabel: this.subProgramForm.DepartmentDirectorApprovalLabel,

                        ProgramsDirectorApprovalRequired: this.subProgramForm.ProgramsDirectorApprovalRequired,
                        ProgramsDirectorApprovalAssignedSignatureLine: this.subProgramForm.ProgramsDirectorApprovalAssignedSignatureLine,
                        ProgramsDirectorApprovalLabel: this.subProgramForm.ProgramsDirectorApprovalLabel,
                        ExecutiveDirectorApprovalRequired: this.subProgramForm.ExecutiveDirectorApprovalRequired,
                        ExecutiveDirectorApprovalAssignedSignatureLine: this.subProgramForm.ExecutiveDirectorApprovalAssignedSignatureLine,
                        ExecutiveDirectorApprovalLabel: this.subProgramForm.ExecutiveDirectorApprovalLabel,
                        AdministrativeAssistantApprovalRequired: this.subProgramForm.AdministrativeAssistantApprovalRequired,
                        AdministrativeAssistantApprovalAssignedSignatureLine: this.subProgramForm.AdministrativeAssistantApprovalAssignedSignatureLine,
                        AdministrativeAssistantApprovalLabel: this.subProgramForm.AdministrativeAssistantApprovalLabel,
                    },
                    this.CreateOrUpdateFormSubProgramMembershipSuccess, () => { }, true);

            },
            CreateOrUpdateFormSubProgramMembershipSuccess(response) {
                this.RefreshDataTable();
                this.CancelSubProgramModal();
            },
            GetFormSubProgram(Id) {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/FormManagement/GetFormSubProgramMembership", {Id: Id}, this.GetFormSubProgramSuccess, () => { }, true);
            },
            GetFormSubProgramSuccess(response) {
                this.FormSubProgramList = response.data.data;
            },
            GetForms() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/FormManagement/GetForms", {}, this.GetFormsSuccess, () => { }, false);
            },
            GetFormsSuccess(response) {
                this.FormList = response.data.data;
                this.$refs.datatable.refresh();
            },
            GetSubPrograms() {
                this.$MasterAPI.ExecuteRequest("GET", "Admin/UserManagement/GetSubPrograms", {}, this.GetSubProgramsSuccess, () => { }, false);

            },
            GetSubProgramsSuccess(response) {
                this.subPrograms = response.data.data;
            },
            SortTable(sortOrder, pagination) {
                console.log(sortOrder);
                return { data: this.LoadedChildren };
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            DeleteSubProgram(){
                this.$MasterAPI.ExecuteRequest("POST", "Admin/UserManagement/DeleteFormMembership", this.DeleteSubProgramSuccess, () => { }, true);

            },
            DeleteSubProgramSuccess(response) {
                this.RefreshDataTable();
                this.$refs['add-component-modal'].hide();
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.FormList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }
                    
                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));
                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                return visibleData;                  
            }
        },        
        components: {
            Vuetable,
            ActionButtonWithIcon,
            flatPickr,
            FormBlock,
            FormBlockBuilder
        },
        computed: {
            LoadedForms: function () {
                return this.FormList;
            },
        },
        mounted() {
            var vm = this;
            this.GetForms();
            this.GetSubPrograms();
            let getFormsFunc = function () {
                vm.GetForms();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getFormsFunc);

        }
    }
</script>

<style scoped>
    .vue-datatable {
        width: 100%;
        display: inline-block;
        overflow-x: auto;
    }
        
</style>